import * as Sentry from "@sentry/react";

export const initSentry = () => {
  const isLocalhost =
    typeof window !== "undefined" &&
    (window.location.hostname.includes("localhost") ||
      window.location.hostname === "127.0.0.1");

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    enabled: !isLocalhost,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      // Filter out DOM errors caused by browser extensions or third-party scripts
      const errorMessage = event.exception?.values?.[0]?.value || "";
      const ignoredPatterns = ["removeChild", "insertBefore"];

      if (ignoredPatterns.some((pattern) => errorMessage.includes(pattern))) {
        return null;
      }

      if (import.meta.env.MODE === "development") {
        console.log("Sentry event:", event);
      }
      return event;
    },
  });
};

export { Sentry };
